import { memo } from 'react';

/**
 * @component ControlLegend
 * @description
 * The `ControlLegend` component renders a legend for different control statuses.
 * It displays three types of controls: "Control", "Critical Control", and "Control Issues",
 * each represented by a colored box and a label.
 *
 * @returns {JSX.Element} A JSX element containing the control legend.
 *
 * @example
 * ```tsx
 * <ControlLegend />
 * ```
 */
const ControlLegend = () => {
  return (
    <div data-cy="control-legend" className="flex pr-3">
      <div className="flex gap-6">
        <div data-cy="control-legend-item-control" className="flex items-center gap-2">
          <div
            id="critical"
            className="bg-control-default h-[1.2rem] w-[1.2rem] cursor-auto rounded-[0.3rem] text-wrap"
          />
          <label>Control</label>
        </div>
        <div data-cy="control-legend-item-critical-control" className="flex items-center gap-2">
          <div id="critical" className="bg-control-critical h-[1.2rem] w-[1.2rem] cursor-auto rounded-[0.3rem]" />
          <label>Critical Control</label>
        </div>
        <div data-cy="control-legend-item-control-issues" className="flex items-center gap-2">
          <div id="non-critical" className="bg-control-issue h-[1.2rem] w-[1.2rem] cursor-auto rounded-[0.3rem]" />
          <label>Control Issues</label>
        </div>
      </div>
    </div>
  );
};

export default memo(ControlLegend);
